import { List, Spinner } from "@snapchat/snap-design-system";
import { type FC } from "react";
import { LoadMore, SpinnerContainer, Visible } from "../../common/components";
import { ItemName, scrollableContainer } from "../../common/styles";
import { Flexbox } from "../../core/components";
import { NoResults } from "../../groups/components";
import { formatLensCount } from "../../common/formatters";
import { fadeIn } from "../../core/styles/Animation";
import { type AffectedGroupModel } from "../models";
import { StyledLensIcon, GroupInfoContainer } from "../container/LensIcon";
import { AbsoluteRoute } from "../../../core/routes";
import { Link, generatePath } from "react-router-dom";
import { DecreaseText } from "../../common/components/text";

interface AffectedGroupsViewProps {
    affectedGroups: readonly AffectedGroupModel[];
    loading: boolean;
    organizationId: string;
    loadMore: () => void;
    isLastPage: boolean;
}

export const AffectedGroupsView: FC<AffectedGroupsViewProps> = ({
    affectedGroups,
    loading,
    organizationId,
    loadMore,
    isLastPage,
}) => (
    <div className={scrollableContainer}>
        <Visible when={affectedGroups.length === 0 && !loading}>
            <NoResults description="No affected groups found" />
        </Visible>
        <Visible when={loading}>
            <SpinnerContainer justifyContent="center">
                <Spinner />
            </SpinnerContainer>
        </Visible>
        <List>
            {affectedGroups.map(({ groupId, groupName, lenses, affectedNumLenses }) => (
                <List.Item key={groupId}>
                    <Flexbox className={fadeIn} alignItems="center">
                        <Flexbox>
                            {lenses.map((lens) => (
                                <StyledLensIcon key={lens?.compoundId?.id} src={lens.iconUrl ?? ""} />
                            ))}
                        </Flexbox>
                        <GroupInfoContainer flexDirection="column" justifyContent="center">
                            {/* TODO: UNCOMMNET ROUTES */}
                            <Link
                                to={generatePath(AbsoluteRoute.ORG_LENS_SCHEDULER_GROUP, {
                                    groupId,
                                    orgId: organizationId,
                                })}
                            >
                                <ItemName>
                                    <DecreaseText width="100%">{groupName}</DecreaseText>
                                </ItemName>
                            </Link>
                            <span>{formatLensCount(affectedNumLenses)}</span>
                        </GroupInfoContainer>
                    </Flexbox>
                </List.Item>
            ))}
        </List>
        <Visible when={affectedGroups.length > 0}>
            <LoadMore onClick={loadMore} loading={loading} isLastPage={isLastPage} />
        </Visible>
    </div>
);
